import { AdvancedGoogleSignInModel } from "./SimpleAuth/GoogleSimpleAuth";


class SimpleAuthController {
    private _google: AdvancedGoogleSignInModel
    constructor(){
        this._google = new AdvancedGoogleSignInModel();
    }

    get google(){
        return this._google
    }
}

export { SimpleAuthController }